﻿export class autocomplete {
    constructor(input, bounds) {

        const autocompleteFormField = input;

        this.initGooglePlacesAutocomplete(autocompleteFormField, bounds);

        autocompleteFormField.addEventListener('propertychange', (event) => {
            var visible = Boolean(autocompleteFormField.value);
            autocompleteFormField.parentElement.querySelector('.form-control-clear').style.setProperty("visibility", (visible ? "visible" : "hidden"), "important");
            autocompleteFormField.parentElement.querySelector('.dropdown').style.setProperty("visibility", (visible ? "hidden" : "visible"), "important");
        });

        autocompleteFormField.parentElement.querySelector('.form-control-clear').addEventListener('click', (event) => {
            autocompleteFormField.value = '';
            autocompleteFormField.dataset.location = ''
            autocompleteFormField.focus();
            autocompleteFormField.dispatchEvent(new Event('propertychange'));
            autocompleteFormField.dispatchEvent(new Event('change'));
        });

        autocompleteFormField.addEventListener('change', (event) => {
            if (event.target.value == "") {
                autocompleteFormField.dataset.location = ''
                autocompleteFormField.dispatchEvent(new Event('propertychange'));
            }
        });

    }

    debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }


    initGooglePlacesAutocomplete(autocompleteFormField, bounds) {
        const sessionToken = new google.maps.places.AutocompleteSessionToken();
        const autocomplete = new google.maps.places.AutocompleteService();
        const predictionList = this.predictionListMarkup();

        autocompleteFormField.parentElement.appendChild(predictionList);


        document.addEventListener('click', () => {
            predictionList.style.display = 'none';
        });


        autocompleteFormField.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (autocompleteFormField.value) {
                predictionList.style.display = 'block';
            }
        });

        autocompleteFormField.addEventListener('input', this.debounce(() => {
            if (autocompleteFormField.value) {
                predictionList.style.display = 'block';
                autocomplete.getPlacePredictions({
                    input: autocompleteFormField.value,
                    sessionToken: sessionToken,
                    locationRestriction: bounds,
                    strictBounds: true
                },
                    (predictions, status) => {
                        this.displayPredictionSuggestions(predictions, status, predictionList, autocompleteFormField);
                    }
                );
            } else {
                predictionList.style.display = 'none';
            }
        }, 200));
    }

    predictionListMarkup() {
        const predictionsWrapperDiv = document.createElement('ul');
        predictionsWrapperDiv.classList.add('pac-container', 'pac-logo');
        return predictionsWrapperDiv;
    }


    displayPredictionSuggestions(predictions, status, predictionList, autocompleteFormField) {

        predictionList.innerHTML = "";
        if (status !== google.maps.places.PlacesServiceStatus.OK) {
            predictionList.style.display = 'none';
            return;
        }
        for (const prediction of predictions) {
            this.predictionBuilder(prediction, predictionList, autocompleteFormField);
        }

        this.autocompleteKeyboardListener(predictions, predictionList, autocompleteFormField);
    }


    predictionBuilder(prediction, predictionList, autocompleteFormField) {
        const typesList = prediction.types;
        let icon;
        switch (true) {
            case (typesList.includes('airport')):
                icon = 'ls:plane';
                break;
            case (typesList.includes('locality')):
                icon = 'mdi-home-city-outline';
                break;
            case (typesList.includes('lodging')):
                icon = 'ri:hotel-line';
                break;
            case (typesList.includes('bus_station')):
                icon = 'local_mall';
                break;
            case (typesList.includes('train_station')):
                icon = 'emojione-monotone:bullet-train';
                break;

            default:
                icon = 'ri:gps-line';
        }


        // strict prediction filtering based on the street address verification.
        const predictionListItem = document.createElement('li');
        predictionListItem.classList.add('pac-item');

        predictionListItem.innerHTML = `<span class="iconify" data-icon="${icon}" data-inline="false" data-width="64" data-height="64"></span>`

        predictionListItem.appendChild(document.createTextNode(prediction.description));
        predictionListItem.addEventListener('click', () => {
            this.autocompleteServiceListener(prediction, predictionList, autocompleteFormField);
        });
        predictionList.appendChild(predictionListItem);
    }


    autocompleteServiceListener(prediction, predictionList, autocompleteFormField) {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ placeId: prediction.place_id },
            (results, status) => {
                if (status == google.maps.GeocoderStatus.OK) {
                    autocompleteFormField.value = results[0].formatted_address;
                    autocompleteFormField.dataset.location = results[0].geometry.location.toUrlValue();
                    autocompleteFormField.dispatchEvent(new Event('propertychange'));
                    predictionList.style.display = 'none';
                } else {
                    alert('Geocode was not successful for the following reason: ' + status);
                }
            });
    }


    autocompleteKeyboardListener(predictions, predictionList, autocompleteFormField) {
        const autocompletePredictionMarkup = document.querySelector('.pac-container');
        this.keyCodeListener = (event) => {

            switch (event.keyCode) {
                case 38:
                    // UP
                    this.upKeyAutocompleteInteraction(autocompletePredictionMarkup, autocompleteFormField);
                    break;

                case 40:
                    // DOWN
                    this.downKeyAutocompleteInteraction(autocompletePredictionMarkup, autocompleteFormField);
                    break;

                case 9:
                    // TAB
                    this.keyboardAutocomplete(predictions, predictionList, autocompleteFormField, this.keyCodeListener);
                    break;

                case 13:
                    // ENTER
                    event.preventDefault();
                    event.stopPropagation();
                    this.keyboardAutocomplete(predictions, predictionList, autocompleteFormField, this.keyCodeListener);
                    break;
            }
        };
        autocompleteFormField.addEventListener('keydown', this.keyCodeListener);
    }

    upKeyAutocompleteInteraction(autocompletePredictionMarkup, autocompleteFormField) {
        if (!(document.querySelector('.pac-selected'))) {
            // Returns the bottom of the list.
            return this.autocompleteListDecorator(autocompletePredictionMarkup.lastChild, autocompleteFormField);
        } else {
            // Transverse the list in reverse order.
            const previousSibling = document.querySelector(`.pac-selected`).previousSibling;
            if (previousSibling) {
                this.autocompleteListDecorator(previousSibling, autocompleteFormField);
            } else {
                // Return to the last list element at the top of the list.
                this.autocompleteListDecorator(autocompletePredictionMarkup.lastChild, autocompleteFormField);
            }
        }
    }

    downKeyAutocompleteInteraction(autocompletePredictionMarkup, autocompleteFormField) {
        if (!(document.querySelector('.pac-selected'))) {
            // Start at the top of the list.
            return this.autocompleteListDecorator(autocompletePredictionMarkup.firstChild, autocompleteFormField);
        } else {
            // Transverse the list from top down.
            const nextSibling = document.querySelector('.pac-selected').nextSibling;
            if (nextSibling) {
                this.autocompleteListDecorator(nextSibling, autocompleteFormField);
            } else {
                // Return to the first list element at the end of the list.
                this.autocompleteListDecorator(autocompletePredictionMarkup.firstChild, autocompleteFormField);
            }
        }
    }

    keyboardAutocomplete(predictions, predictionList, autocompleteFormField, keyCodeListener) {
        if (document.querySelector('.pac-selected').innerText) {
            for (const prediction of predictions) {
                if (document.querySelector('.pac-selected').innerText === prediction.description) {
                    this.autocompleteServiceListener(prediction, predictionList, autocompleteFormField);
                }
            }
            document.querySelector('.pac-selected').classList.remove('pac-selected');
            autocompleteFormField.removeEventListener('keydown', keyCodeListener);
        }
    }

    autocompleteListDecorator(autocompletePredictionMarkup, autocompleteFormField) {
        if (document.querySelector('.pac-selected')) {
            document.querySelector('.pac-selected').classList.remove('pac-selected');
        }

        autocompleteFormField.value = autocompletePredictionMarkup.innerText;
        autocompletePredictionMarkup.classList.add('pac-selected');
    }
}